export default __webpack_public_path__ + "static/media/file-alt.360389de.svg";